import React, { useState, useEffect, useCallback, useMemo } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import DataTable from "react-data-table-component";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import moment from "moment";
import { http } from "../helper";
import {
  capitalizeFirstLetter,
  dateformatwithuktime,
} from "../utilityfunctions";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";

const PromoOffers = () => {
  const { t } = useTranslation();

  const priceFormat = (price) => {
    if (price == null || isNaN(price)) {
      return t("price_placeholder_txt");
    }
    return price.toLocaleString("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px", // override the cell padding for head cells
      },
    },
    cells: {
      style: {
        padding: "8px", // override the cell padding for data cells
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  const conditionalRowStyles = [
    {
      when: (row) =>
        moment(row.FromDate, "YYYY-MM-DD").isBefore(moment(), "day"),
      style: {
        backgroundColor: "#ffcccc", // Light red for expired rows
        color: "#000", // Optional: Adjust text color for visibility
      },
    },
  ];
  const [searchTextVal, setSearchTextVal] = useState("");
  const [promotionslist, setPromotionslist] = useState([]);
  const [templist, setTemplist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [freeproductpdfvalue, setFreeproductpdfvalue] = useState("");
  const [activeTab, setActiveTab] = useState("cart");
  const [sectorPromotionsList, setSectorPromotionsList] = useState([]);
  const [sectorOptions, setSectorOptions] = useState([]);
  const [searchSectorTextVal, setSearchSectorTextVal] = useState("");
  const [sectorVal, setSectorVal] = useState("");
  const [deleteAlert, setDeleteAlert] = useState(false);

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_promooffers")
  ) {
    window.location.href = "/unauthorized";
  }

  const getPromotionslist = useCallback(() => {
    setLoading(true);
    let URL = BaseUrl + "admin/listpromooffers";
    http
      .get(URL)
      .then((response) => {
        // Sort by sortOrder
        let responseData = response.data.data.sort(
          (a, b) => a.cartAmountTarget - b.cartAmountTarget,
        );
        setPromotionslist(responseData);
        setLoading(false);
        setTemplist(responseData);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  const getSectorPromotionsList = useCallback(() => {
    let URL = BaseUrl + "admin/listsectorpromooffers";
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data.sort(
          (a, b) => a.cartAmountTarget - b.cartAmountTarget,
        );
        setSectorPromotionsList(responseData);
        setLoading(false);
        setTemplist(responseData);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleTabChange = useCallback(
    (tab) => {
      const url = new URL(window.location);
      url.searchParams.set("tab", tab);
      window.history.pushState({}, "", url);
      setActiveTab(tab);
      setLoading(true);
      if (tab === "cart") {
        getPromotionslist();
      } else {
        getSectorPromotionsList();
      }
    },
    [getPromotionslist, getSectorPromotionsList],
  );

  const editPromoOffers = useCallback((editid) => {
    window.location.href = `/promooffers/edit/${editid}`;
  }, []);

  const editsectorPromoOffers = useCallback((editid) => {
    window.location.href = `/promooffers/sector/edit/${editid}`;
  }, []);

  const deletePromoOffers = useCallback((value) => {
    setVisibleAlert(true);
    setFreeproductpdfvalue(value);
  }, []);

  const deletePromoOffersdetails = useCallback(() => {
    let URL = BaseUrl + `admin/deletepromooffers/${freeproductpdfvalue._id}`;
    http
      .delete(URL)
      .then(async (response) => {
        if (response.data.success === true) {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [freeproductpdfvalue]);

  const alertPopupclose = useCallback(() => {
    setVisibleAlert(false);
    setFreeproductpdfvalue("");
  }, []);

  const deletesectorPromoOffers = useCallback((value) => {
    setDeleteAlert(true);
    setSectorVal(value);
  }, []);

  const deletesectorPromoOffersdetails = useCallback(() => {
    let URL = BaseUrl + `admin/deletesectorpromooffers/${sectorVal._id}`;
    http
      .delete(URL)
      .then(async (response) => {
        if (response.data.success === true) {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [sectorVal]);

  const alertDeletePopupclose = useCallback(() => {
    setDeleteAlert(false);
    setSectorVal("");
  }, []);

  const areAllSectorsUsed = useCallback(() => {
    if (!sectorOptions.length) return false;
    const usedSectorNames = sectorPromotionsList.map((item) => item.sectorName);
    return sectorOptions.every((sector) =>
      usedSectorNames.includes(sector.name),
    );
  }, [sectorOptions, sectorPromotionsList]);

  const addPromotion = useCallback(() => {
    window.location.href = "/promooffers/add";
  }, []);

  const addSectorPromotion = useCallback(() => {
    window.location.href = "/promooffers/sector/add";
  }, []);

  const filterData = useCallback(
    (value) => {
      let accoun = templist;
      let result = [];
      if (value.length > 0) {
        accoun.forEach((item) => {
          if (item.cartAmountFrom == value || item.cartAmountTo == value) {
            result.push(item);
          }
        });
        setPromotionslist(result);
      } else {
        setPromotionslist(accoun);
      }
    },
    [templist],
  );

  const filterSectorData = useCallback(
    (value) => {
      let accoun = templist;
      let result = [];
      if (value.length > 0) {
        accoun.forEach((item) => {
          if (
            item.cartAmountFrom == value ||
            item.cartAmountTo == value ||
            item.sectorName.toLowerCase().includes(value.toLowerCase())
          ) {
            result.push(item);
          }
        });
        setSectorPromotionsList(result);
      } else {
        setSectorPromotionsList(accoun);
      }
    },
    [templist],
  );

  const handleReset = useCallback(() => {
    setSearchTextVal("");
    setPromotionslist(templist);
  }, [templist]);

  const handleChange = useCallback(
    (value) => {
      setSearchTextVal(value);
      filterData(value);
    },
    [filterData],
  );

  const handleSectorChange = useCallback(
    (value) => {
      setSearchSectorTextVal(value);
      filterSectorData(value);
    },
    [filterSectorData],
  );

  const handleSectorReset = useCallback(() => {
    setSearchSectorTextVal("");
    setSectorPromotionsList(templist);
  }, [templist]);

  const fetchSectors = useCallback(async () => {
    try {
      const URL = `${BaseUrl}admin/product/masterentries/sectors`;
      const response = await http.get(URL);
      if (response.data?.success) {
        const sectors = response.data.data;
        const formatted = sectors.map((item) => ({
          name: item.MasterValue,
          value: item.MasterId,
        }));
        setSectorOptions(formatted);
      }
    } catch (err) {
      console.error("Failed to fetch sectors", err);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get("tab");
    fetchSectors();
    if (tab === "sector") {
      setActiveTab("sector");
      getSectorPromotionsList();
    } else {
      setActiveTab("cart");
      getPromotionslist();
    }
  }, []);

  const columns = useMemo(
    () => [
      {
        name: t("cart_value_from_txt"),
        selector: (row) => priceFormat(row.cartAmountFrom),
        sortable: true,
      },
      {
        name: t("cart_value_to_txt"),
        selector: (row) => priceFormat(row.cartAmountTo),
        sortable: true,
      },
      {
        name: t("target_cart_value_txt"),
        selector: (row) => priceFormat(row.cartAmountTarget),
        sortable: true,
      },
      {
        name: t("status_txt"),
        selector: (row) => capitalizeFirstLetter(row.Status),
        sortable: true,
      },
      {
        name: t("date_created_txt"),
        selector: (row) => dateformatwithuktime(row.createdAt),
        sortable: true,
      },
      {
        name: t("actions_txt"),
        selector: (row) => {
          const canEdit = canAction("manage_promooffers", "edit");
          return (
            <div style={{ display: "flex" }}>
              <a
                className="editbtn button title-tooltip title-up"
                data-title={canEdit ? t("edit_txt") : t("view_txt")}
                style={{ color: "white" }}
                onClick={() => editPromoOffers(row._id)}
              >
                <i
                  className={`fa ${canEdit ? "fa-pencil" : "fa-eye"}`}
                  aria-hidden="true"
                ></i>
              </a>
              {canAction("manage_promooffers", "delete") && (
                <a
                  className="editbtn button title-tooltip title-up"
                  data-title={t("delete_txt")}
                  style={{ color: "white" }}
                  onClick={() => deletePromoOffers(row)}
                >
                  <i className="fa fa-trash" aria-hidden="true"></i>
                </a>
              )}
            </div>
          );
        },
        sortable: false,
      },
    ],
    [editPromoOffers, deletePromoOffers],
  );

  const sectorColumns = useMemo(
    () => [
      {
        name: t("cus_sector_txt"),
        selector: (row) => row.sectorName,
        sortable: true,
      },
      {
        name: t("target_cart_value_txt"),
        selector: (row) => `> ${priceFormat(row.cartAmountTarget)}`,
        sortable: true,
      },
      {
        name: t("status_txt"),
        selector: (row) => capitalizeFirstLetter(row.Status),
        sortable: true,
      },
      {
        name: t("date_created_txt"),
        selector: (row) => dateformatwithuktime(row.createdAt),
        sortable: true,
      },
      {
        name: t("actions_txt"),
        selector: (row) => {
          const canEdit = canAction("manage_promooffers", "edit");
          return (
            <div style={{ display: "flex" }}>
              <a
                className="editbtn button title-tooltip title-up"
                data-title={canEdit ? t("edit_txt") : t("view_txt")}
                style={{ color: "white" }}
                onClick={() => editsectorPromoOffers(row._id)}
              >
                <i
                  className={`fa ${canEdit ? "fa-pencil" : "fa-eye"}`}
                  aria-hidden="true"
                ></i>
              </a>
              {canAction("manage_promooffers", "delete") && (
                <a
                  className="editbtn button title-tooltip title-up"
                  data-title={t("delete_txt")}
                  style={{ color: "white" }}
                  onClick={() => deletesectorPromoOffers(row)}
                >
                  <i className="fa fa-trash" aria-hidden="true"></i>
                </a>
              )}
            </div>
          );
        },
        sortable: false,
      },
    ],
    [editsectorPromoOffers, deletesectorPromoOffers],
  );

  return (
    <>
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container food-partner-cms">
              <h1 className="checkout-title">{t("promo_offer_txt")}</h1>
              <div className="right-table-outer-wrap">
                {activeTab === "cart" ? (
                  <div className="table-filter search-orders">
                    <div className="table-search-reset">
                      <div className="table-search">
                        <input
                          type="text"
                          value={searchTextVal}
                          onChange={(e) => handleChange(e.target.value)}
                          className="form-control"
                          placeholder={t("search_cart_value_txt")}
                        />
                      </div>
                      <button
                        className="submitbtn button search-ord-btn"
                        onClick={(e) => filterData(searchTextVal)}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                      <button
                        className="resetbtn"
                        type="reset"
                        onClick={handleReset}
                      >
                        {t("reset_txt")}
                      </button>
                    </div>
                    {canAction("manage_promooffers", "add") && (
                      <div className="add-holidaybtn">
                        <button className="addbtn" onClick={addPromotion}>
                          {t("add_txt")}
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="table-filter search-orders">
                    <div className="table-search-reset">
                      <div className="table-search">
                        <input
                          type="text"
                          value={searchSectorTextVal}
                          onChange={(e) => handleSectorChange(e.target.value)}
                          className="form-control"
                          placeholder={t("search_by_sector_cart_amount_txt")}
                        />
                      </div>
                      <button
                        className="submitbtn button search-ord-btn"
                        onClick={(e) => filterSectorData(searchSectorTextVal)}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                      <button
                        className="resetbtn"
                        type="reset"
                        onClick={handleSectorReset}
                      >
                        {t("reset_txt")}
                      </button>
                    </div>
                    {canAction("manage_promooffers", "add") &&
                      !areAllSectorsUsed() && (
                        <div className="add-holidaybtn">
                          <button
                            className="addbtn"
                            onClick={addSectorPromotion}
                          >
                            {t("add_txt")}
                          </button>
                        </div>
                      )}
                  </div>
                )}
                <div className="header-tab-menu">
                  <a
                    className={activeTab === "cart" ? "active" : ""}
                    onClick={() => handleTabChange("cart")}
                  >
                    {t("cart_based_promo_offers_txt")}
                  </a>
                  <a
                    className={activeTab === "sector" ? "active" : ""}
                    onClick={() => handleTabChange("sector")}
                  >
                    {t("sector_based_promo_offers_txt")}
                  </a>
                </div>
                {activeTab === "cart" ? (
                  <div className="table_overflow promotions-data-table">
                    <DataTable
                      columns={columns}
                      noDataComponent={
                        <div className="no-records-found">
                          {t("no_cart_promo_offer_records_txt")}
                        </div>
                      }
                      data={promotionslist}
                      customStyles={customStyles}
                      pagination
                      paginationPerPage={50}
                      progressPending={loading}
                      paginationRowsPerPageOptions={[50, 100, 150, 200]}
                      paginationComponentOptions={paginationComponentOptions}
                      conditionalRowStyles={conditionalRowStyles} // Apply row highlighting
                    />
                  </div>
                ) : (
                  <div className="table_overflow sector-promotions-data-table">
                    <DataTable
                      columns={sectorColumns}
                      noDataComponent={
                        <div className="no-records-found">
                          {t("no_sector_promo_offer_records_txt")}
                        </div>
                      }
                      data={sectorPromotionsList}
                      pagination
                      paginationPerPage={50}
                      progressPending={loading}
                      customStyles={customStyles}
                      paginationRowsPerPageOptions={[50, 100, 150, 200]}
                      paginationComponentOptions={paginationComponentOptions}
                      conditionalRowStyles={conditionalRowStyles}
                    />
                  </div>
                )}
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </div>
      {visibleAlert === true && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("delete_confirm_txt")}</p>
                <div className="alert-buttons">
                  <a
                    onClick={deletePromoOffersdetails}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    onClick={alertPopupclose}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {deleteAlert === true && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("delete_confirm_txt")}</p>
                <div className="alert-buttons">
                  <a
                    onClick={deletesectorPromoOffersdetails}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    onClick={alertDeletePopupclose}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PromoOffers;
